<template>
  <div class="carousel-thumbnail">
    <VueAgile class="main-carousel"
              ref="main"
              :options="options1"
              :as-nav-for="asNavFor1"
              :infinite="infinite"
              @after-change="handleAfterChange"
    >
      <div class="slide" 
           v-for="(slide, index) in slideShows"
           :key="`preview-${index}`"
           :class="`slide--${index}`" 
           >
        <div class="slide-wrapper">
          <div class="slide-image">
            <div v-if="!previewOnly" class="justify-end sm:hidden count-index ">
              {{ index + 1 }}/{{ slideShows.length }}
            </div>
            <img class="item-img" :src="getImgUrl(slide)" v-if="!isSmall"/>
            <img class="item-img_small" :src="getImgUrl(slide)" v-else/>
          </div>
          <span v-show="showLabel" class="label-text one-lines-ellipsis">{{ slide.label }}</span>
        </div>
      </div>
     
      <template v-slot:prevButton>
        <i class="icon icon-bor-arrow-left"></i>
      </template>
      <template v-slot:nextButton>
        <i class="icon icon-bor-arrow-right" ></i>
      </template>
    </VueAgile>

    <VueAgile class="thumbnails-carousel"
              ref="thumbnails"
              :options="options2"
              :as-nav-for="asNavFor2"
              :infinite="infinite"
              v-if="!previewOnly">
      <div class="slide slide--thumbnail"
           v-for="(slide, index) in slideShows"
           :key="`slide-thumbnail-${index}`"
           :class="[`slide--${index}`, index == activeImg ? 'active' : '']"
           @click="$refs.thumbnails.goTo(index)">
        <img class="item-img" :src="slide.imageUrl" />
      </div>
    </VueAgile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'

export default {
  name: 'CarouselThumbnail',
  props: {
    slides: {
      type: Array,
      default: () => {
        return []
      }
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    slidesToShow: {
      default: 5
    },
    previewOnly: {
      type: Boolean,
      default: false
    },
    infinite: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueAgile
  },
  data() {
    return {
      activeImg: -1,
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        dots: false,
        fade: true,
        navButtons: true,
        mobileFirst: true
      },
      options2: {
        autoplay: false,
        dots: false,
        centerMode: true,
        navButtons: false,
        initialSlide: 0,
        slidesToShow: 5
      },
      slideShows: []
    }
  },
  created() {
    if (this.slides && Array.isArray(this.slides)) {
      this.slideShows = this.slides
    }
    if (+this.slidesToShow) {
      this.options2.slidesToShow = +this.slidesToShow
    }
  },
  mounted() {
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
  },
  watch: {
    slides(value) {
      this.slideShows = value
      this.$nextTick(() => {
        this.$refs.main.reload()
        this.$refs.thumbnails.reload()
      })
    }
  },
  methods: {
    handleAfterChange($event) {
      this.activeImg = $event.currentSlide
      this.$emit('change', this.slideShows[$event.currentSlide])
    },
    getImgUrl(filename) {
      if(filename.imageUrl) {
        return filename.imageUrl
      }
      return require('@/assets/images/slide-img-placeholder.png')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

/deep/ .agile__actions {
  width: calc(100% - 0px);
  position: absolute;
  top: calc(50% - 10px);
  left: 0px;
}
/deep/ .agile__actions .agile__nav-button {
  @apply flex justify-center items-center;
  width: 22px;
  height: 30px;
  background: #1f2021a3;
  color: #fff;
}
/deep/ .agile__actions .agile__nav-button.agile__nav-button--prev {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
/deep/ .agile__actions .agile__nav-button.agile__nav-button--next {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
</style>
